import { render, staticRenderFns } from "./PersonalTrainerIcon.vue?vue&type=template&id=c9b20baa&"
import script from "./PersonalTrainerIcon.vue?vue&type=script&lang=js&"
export * from "./PersonalTrainerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports